import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=572c5170&scoped=true&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"
import style1 from "./balance.vue?vue&type=style&index=1&id=572c5170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c5170",
  null
  
)

export default component.exports